import type { DocumentContext } from '@ContractBuilder/utils';
import type { ResourceBlock } from '@domain/schemas/contract.schema';
import type { EntityData } from '@domain/types/entity';
import type { BaseUser } from '@helpers/auth/types';
import { canChange } from '@helpers/canChange';

import { crossCheckBlockUserCtx } from './cross-check-block-user-ctx';

export type BlockRulesIsDeletableArgs = {
  block: ResourceBlock;
  context: DocumentContext;
  status: EntityData['status'];
  user: BaseUser | null;
};

export const blockRulesIsDeletable = ({ block, context, status, user }: BlockRulesIsDeletableArgs) => {
  const documentConditionsAllowChange = canChange(status);
  const { canBeDeletedWithCurrentPermissions } = crossCheckBlockUserCtx(block, context, user);

  if (!documentConditionsAllowChange || !canBeDeletedWithCurrentPermissions) {
    return false;
  }

  return canBeDeletedWithCurrentPermissions;
};
